import _sfc_main from "./BuyBoxColorSelector2.mjs";
/* empty css                      */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBoxColorSelector = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-23665407"]]);
export {
  BuyBoxColorSelector as default
};
//# sourceMappingURL=BuyBoxColorSelector.mjs.map
